var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callback-dialog"},[_c('ModalDialog',{ref:"dialog",attrs:{"is-mini":true},on:{"hide":_vm.onHide}},[_c('Callback',{staticClass:"callback col-4 col-md-12"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }